/* Vivid light motion: scroll reveal, gentle card tilt. Respects reduced motion. */
(function () {
  if (window.__vneMotion) return;
  window.__vneMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  function init() {
    var sel = '.vne__head, .vne-cat, .vne-pcard, .vne-bundle, .vne-guide, .vne-campaign__panel, .vne-bset, .vne-landing__hero, [data-vne-reveal]';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) return; /* already on screen: leave it as is */
        var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--vne-delay', Math.min(sibs, 5) * 70 + 'ms');
        el.classList.add('vne-reveal');
        io.observe(el);
      });
    }

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.querySelectorAll('.vne-cat, .vne-bundle, .vne-guide').forEach(function (card) {
        card.classList.add('vne-tilt');
        card.addEventListener('pointermove', function (ev) {
          var r = card.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width - 0.5;
          var y = (ev.clientY - r.top) / r.height - 0.5;
          card.style.setProperty('--vne-rx', (-y * 5).toFixed(2) + 'deg');
          card.style.setProperty('--vne-ry', (x * 6).toFixed(2) + 'deg');
        });
        card.addEventListener('pointerleave', function () {
          card.style.setProperty('--vne-rx', '0deg');
          card.style.setProperty('--vne-ry', '0deg');
        });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
